import { useCallback, useEffect } from "react";
import { useApiTermosUso } from "./api/common";

export const useConsultTerms = () => {
  const [getTerms, { data: termsData, loading: loadingTermsData }] =
    useApiTermosUso();

  const loadTerms = useCallback(async () => {
    try {
      await getTerms();
    } catch {
      // do nothing
    }
  }, [getTerms]);

  useEffect(() => {
    void loadTerms();
  }, [loadTerms]);

  return {
    termsOfUse: termsData?.results[0].termos_de_uso || "",
    privacyPolicy: termsData?.results[0].politica_privacidade || "",
    loadingTermsData,
  };
};
